import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/new-content-login.png'
import _imports_1 from '@/images/logo-login.png'


const _withScopeId = n => (_pushScopeId("data-v-76221b10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "box-thumb"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "hero-image-fade",
  preview: false
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"hero-content\" data-v-76221b10><h1 class=\"hero-fade hero-fade-1\" data-v-76221b10> Assinatura eletrônica <span style=\"color:#0664ce;\" data-v-76221b10>segura </span> e <span style=\"color:#56c24d;\" data-v-76221b10>confiável</span></h1><p class=\"hero-fade hero-fade-2\" data-v-76221b10> Tecnologia e segurança para simplificar seu dia a dia e proteger o que importa. </p><div class=\"hero-features\" data-v-76221b10><span class=\"hero-fade hero-fade-3\" data-v-76221b10>🔒 Segurança ponta a ponta</span><span class=\"hero-fade hero-fade-4\" data-v-76221b10>👥 Múltiplos signatários</span><span class=\"hero-fade hero-fade-5\" data-v-76221b10>📄 Validade jurídica</span></div></div>", 1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "box-content" }
const _hoisted_7 = { class: "box-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "account-card"
}
const _hoisted_9 = {
  key: 1,
  class: "account-card"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "content-account" }, [
  /*#__PURE__*/_createElementVNode("section", { class: "content-header" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "header-logo" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: "Acesso ao Sistema",
        preview: false
      })
    ])
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Ir para o login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["account-card", { 'is-success': _ctx.success, 'is-error': _ctx.error }])
        }, [
          (_ctx.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_a_spin, { indicator: _ctx.indicator }, null, 8, ["indicator"])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_9, [
                _hoisted_10,
                (_ctx.success)
                  ? (_openBlock(), _createBlock(_component_a_result, {
                      key: 0,
                      status: "success",
                      title: _ctx.title,
                      "sub-title": _ctx.subTitle,
                      class: "active-account-success"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CheckCircleFilled, { class: "success-ic" })
                      ]),
                      extra: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          class: "btn-action-certificata",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToLogin()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title", "sub-title"]))
                  : _createCommentVNode("", true),
                (_ctx.error)
                  ? (_openBlock(), _createBlock(_component_a_result, {
                      key: 1,
                      status: "error",
                      title: _ctx.title,
                      "sub-title": _ctx.subTitle,
                      class: "active-account-error"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_CloseCircleFilled, { class: "error-ic" })
                      ]),
                      _: 1
                    }, 8, ["title", "sub-title"]))
                  : _createCommentVNode("", true)
              ]))
        ], 2),
        _createVNode(_component_Footer)
      ])
    ])
  ]))
}